"use client";
import CustomHeader from "@/src/components/header/header";
import Footer from "@/src/components/footer/Footer";
import "./style.css";
import Tabs from "antd/es/tabs";
import phoneSVG from "@/src/assets/images/contactUs/phone.svg";
import emailSVG from "@/src/assets/images/contactUs/email.svg";
import { useEffect, useState } from "react";

function page() {
	const formOnSubmit = async (e, type) => {
		e.preventDefault();
		var data = new FormData(e.target);
		const formObject = Object.fromEntries(data.entries());
		if (
			!formObject.name?.length ||
			!formObject.email?.length ||
			!formObject.message?.length
		) {
			alert("Enter all info.");
			return;
		}
		try {
			await fetch("/api/send-email", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ ...formObject, ...{ type } }),
			});
			e.target.reset();
			alert("Enquiry Submitted.");
		} catch (e) {
			alert("Error submitting enquiry.");
		}
	};
	const items = [
		{
			key: "1",
			label: "Business Related",
			children: (
				<form
					onSubmit={(e) => {
						formOnSubmit(e, "Business");
					}}
				>
					<div className="contact_us_page_form_div">
						<p className="contact_us_page_form_title">
							Get start with a free quotation
						</p>
						<div className="contact_us_page_form_input">
							<p>Name</p>
							<input
								type="text"
								name="name"
								placeholder="Enter your name"
							/>
						</div>
						<div className="space"></div>
						<div className="contact_us_page_form_input">
							<p>Email</p>
							<input
								type="email"
								name="email"
								placeholder="Enter your valid email address"
							/>
						</div>
						<div className="space"></div>
						<div className="contact_us_page_form_input">
							<p>Message</p>
							<textarea
								name="message"
								placeholder="Enter your message"
							/>
						</div>
						<div className="space"></div>
						<button>Submit Your Request</button>
					</div>
				</form>
			),
		},
		{
			key: "2",
			label: "Driver Related",
			children: (
				<form
					onSubmit={(e) => {
						formOnSubmit(e, "Driver");
					}}
				>
					<div className="contact_us_page_form_div driver">
						<p className="contact_us_page_form_title">
							Get start with a free quotation
						</p>
						<div className="contact_us_page_form_input">
							<p>Name</p>
							<input
								type="text"
								name="name"
								placeholder="Enter your name"
							/>
						</div>
						<div className="space"></div>
						<div className="contact_us_page_form_input">
							<p>Phone no</p>
							<input
								type="text"
								name="phone"
								placeholder="Enter your phone number"
							/>
						</div>
						<div className="space"></div>
						<p className="radio_selector_heading">
							Select vehicle type
						</p>

						<input
							className="radio_input"
							type="radio"
							id="2Wheeler"
							name="fav_language"
							value="2-wheeler"
						/>
						<label for="2Wheeler">2 Wheeler</label>
						<input
							className="radio_input "
							type="radio"
							id="3Wheeler"
							name="fav_language"
							value="3_wheeler"
						/>
						<label for="3Wheeler">3 Wheeler</label>
						<br />
						<input
							className="radio_input"
							type="radio"
							id="4Wheeler"
							name="fav_language"
							value="4_wheeler"
						/>
						<label for="4Wheeler">4 Wheeler</label>
						<br />
						<div className="space"></div>
						<button>Submit Your Request</button>
					</div>
				</form>
			),
		},
	];
	const [script, setScript] = useState();
	useEffect(() => {
		setScript(
			JSON.stringify({
				"@context": "https://schema.org",
				"@type": "ContactPage",
				url: "https://zevoindia.in/contact-us",
				mainEntity: {
					"@type": "Organization",
					name: "Zevo India",
					url: "https://zevoindia.in",
					contactPoint: [
						{
							"@type": "ContactPoint",
							telephone: "+918826404013",
							email: "office@zevoindia.in",
							contactType: "General Inquiries",
						},
					],
				},
			}),
		);
	});
	return (
		<>
			<script type="application/ld+json">{script}</script>
			<CustomHeader />
			<div className="contact_us_page">
				<div className="contact_us_page_desc">
					<h1 className="contact_us_page_desc_head">Get in touch</h1>
					{/* <p className="contact_us_page_desc_desc">
						We’d love to here from you.
						<br /> Here’s what some of my satisfied clients have to
						say about my work
					</p> */}
					<div className="department_contact_info">
						<h4>CEO’s Office</h4>
						CA Aditya Singh Ratnu | 9818560034 | aditya@zevoindia.in
					</div>
					<div className="department_contact_info">
						<h4>COO’s Office</h4>
						CA Dhruv Bhatia | 9818560028 | dhruv@zevoindia.in
					</div>
					<div className="department_contact_info">
						<h4>Chief Mobility Officer</h4>
						Avinash Chopra | 9810374203 | avinash@zevoindia.in
					</div>
					<div className="department_contact_info">
						<h4>Business Development Head</h4>
						Somesh Sharma | 9654779492 | somesh@zevoindia.in
					</div>
					<div className="department_contact_info">
						<h4>Operations Head</h4>
						Naman Malhotra | 8800769854 | naman@zevoindia.in
					</div>
					<div className="department_contact_info">
						<h4>2 Wheeler Queries</h4>
						9990204000 | operations@zevoindia.in
					</div>
					<div className="department_contact_info">
						<h4>HR</h4>
						8826404013 | hr@zevoindia.in
					</div>
					<div className="pc">
						<p className="contact_us_page_desc_body">
							Feel free to get in touch with us via email or phone
						</p>
						<div>
							<div className="contact_us_page_desc_contact_div">
								<div className="contact_us_page_desc_contact_icon">
									<img src={phoneSVG.src} alt="phoneSVG" />
								</div>
								<div className="contact_us_page_desc_contact_info">
									<p>011-3567-9455</p>
								</div>
							</div>
							<div className="contact_us_page_desc_contact_div">
								<div className="contact_us_page_desc_contact_icon">
									<img src={emailSVG.src} alt="emailSVG" />
								</div>
								<div className="contact_us_page_desc_contact_info">
									<p>operations@zevoindia.in</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="contact_us_page_form">
					<Tabs
						defaultActiveKey="1"
						items={items}
						className="contact_us_page_form_tabs"
					/>
				</div>
				<div className="contact_us_page_desc_contact_div_mobile mobile">
					<p className="contact_us_page_desc_body">
						Feel free to get in touch with us via email or phone
					</p>
					<table className="contact_us_page_desc_contact_div">
						<tbody>
							<tr>
								<td>
									<div className="contact_us_page_desc_contact_icon">
										<img
											src={phoneSVG.src}
											alt="phoneSVG"
										/>

										<p>+91-9818560034</p>
									</div>
								</td>
								<td>
									<div className="contact_us_page_desc_contact_icon">
										<img
											src={emailSVG.src}
											alt="emailSVG"
										/>

										<p>aditya@zevoindia.in</p>
									</div>
								</td>
							</tr>
							<tr>
								<td>
									<div className="contact_us_page_desc_contact_icon">
										<img
											src={phoneSVG.src}
											alt="phoneSVG"
										/>

										<p>011-3567-9455</p>
									</div>
								</td>
								<td>
									<div className="contact_us_page_desc_contact_icon">
										<img
											src={emailSVG.src}
											alt="emailSVG"
										/>

										<p>operations@zevoindia.in</p>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default page;
